
export default {
  button: {
    closeWindow:"Close Window",
    sortBy:"Sort By",
    allRead: "Mask all as read",
    cropImg: "Crop Image",
    cancel: "Cancel",
    confirm: "Confirm",
    login: "Log in",
    register: "Sign Up",
    addToCart: "Add To Cart",
    purchase: "Purchase",
    viewPrivileges: "View Privileges",
    close: "Close",
    seeAll: "See All",
    selectPackage: "Select Package",
    checkIn: "Class Check-in",
    clickToClockIn: "Mark attendance",
    alreadyClockIn: "Attendance marked",
    save: "Save",
    search: "Search...",
    or: "OR",
    upload: "Upload",
    preview: "Preview",
    accept: "Accept",
    decline: "Decline",
    viewMore: "View More",
  },
  message: {
    courseType:"Course Type",
    recommandCategory: "Recommended Spheres",
    hotCategory: "Popular Spheres",
    register: "Register",
    login: "Login",
    confirm: "Confirm",
    //---------------------------
    courseDetail: "Course Details",
    packageDetail: "Package Details",
    benefits: "Benefits",
    seeMore: "See More Details",
    buyThisCourse: "Buy course/Add to Cart",
    reserveThisCourse: "Reserve course",
    addToCart: "Add to Cart",
    seats: "Seats",
    hoursPerTime: "Hours/Session",
    selectPackage: "Select This Package!",
    selectedPackage: "Selected Package",
    selectPackageStep: "Select Package",
    selectDateStep: "Select Class Time & Coach",
    selectStudentStep: "Enter Student Information",
    seftRegister: "Register for Myself",
    otherResgister: "Register for Someone Else",
    fillParentInfo: "Fill in Guardian Information",
    ParentPhone: "Guardian Phone Number",
    studntCount: "Student Number",
    level: "Grade Level",
    bath: "Bath",
    courseNotFound: "No courses found.",
    changePasssword: "Change Password",
    history: "History",

    //------------------------
    purchaseHistory: "Order History",
    notification: "Notifications",
    cart: "Cart",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    all: "All",
    close: "Close",
    price: "Price",
    purchase: "Pay Now",
    totalPrice: "Total Price",
    pendingPayment: "Pending",
    completedPayment: "Completed",
    cancelledPayment: "Cancelled",
    orderID: "Order ID",
    //Form
    firstname: "First Name",
    lastname: "Last Name",

    phone: "Phone Number",
    email: "Email",
    school: "School",
    allergy: "Medical Conditions/Food Allergies",
    changeProfile: "Change Profile Picture",
    delete: "Delete",
    edit: "Edit",
    selectAll: "Select All",
    profile: "Profile",

    notSpecified: "Not Specified",
  },
  language: {
    th: "Thai",
    en: "English",
  },
  rules: {
    otherDiscount: "Discount must not exceed {amount} baht",
    required: "This field is required.",
    email: "The email address format is incorrect",
    minLength: "Please enter at least ",
    minPassword: "Minimum length is 8 characters.",
    englishRule: "English letters",
    numberRule: "Arabic numerals",
    maxLength: "Please enter no more than",
    minStudent: "At least 1 student is required.",
    char: "characters",
    password:
      "Password must contain at least 1 English letter, 1 number, and be at least 8 characters long.",
    matchPassword: "Passwords do not match",
    emailPassNotMatch: "Password and confirmation must be the same.",
    thai: "Please fill out the form in Thai.",
    eng: "Please fill out the form in English.",
    text: "Please enter text only.",
    phone: "The phone number format is incorrect, Please try again.",
    format: "Invalid format. Please check.",
    discount: "Discount must be less than the course price.",
    period: "Please check the start date and end date again.",
  },
  formError: {
    courseName: "This course name has already been taken",
  },
  errorMessage: {
    noExportData: "No data available for export",
    invalidReserveDate: "Reservation is not allowed at this time.",
    enrollSchedule: "This course cannot be purchased because the schedule does not match the class dates.",
    enrollRole: "Unable to enroll in this course because the user's role is incorrect.",
    enrollCoach: "Unable to enroll in this course because no coach is available to teach at this time.",
    enrollDate: "Unable to enroll in this course because it is not open for enrollment at this time.",
    orderNotFound: "No orders available to export",
    pleaseFillAllFieldsCorrectly:
      "Please fill in all fields completely and correctly.",
    conflictScheudle:
      "Unable to modify the schedule as the coach already has a class during this period.",
    conflictCheckIn:
      "Unable to modify the class schedule because the assigned coach has already checked in for this session.",

    // Change Role Error
    stillStudy: "Role cannot be changed while the user is still studying.",
    stillTeach: "Cannot change role while the user is still teaching.",

    sameCateforyName: "This sphere name is already in use.",
    noStudentFound: "No student list found for this session.",
    uploadImageAndVideo: "Only images and videos are allowed to upload.",
    uploadOnlyImage: "Only image files are allowed to upload.",
    successDel: "Data deleted successfully!",
    failDel:
      "Failed to delete data. Please check the information and try again.",
    cannotRegister:
      "Registration failed. Please check your details and try again.",
    dulicateUsername: "This username is already taken",
    dulicateEmail: "This email is already taken",
    coachNotFound: "No coaches are currently available during this time.",
    userNotFound: "User not found.",
    userAlreadyAdded:
      "You have already added this user as a learner. Please select another learner.",
    cannotAddSelf:
      "You cannot add yourself here. Please select another learner.",
    courseNotFound: "We couldn’t find any courses you might be interested in.",
    cantAddNotStudent:
      "This user cannot be registered as a student due to an incompatible role.",
    cantAddAsParent:
      "This user cannot be added as your guardian due to an incompatible role.",
    cantAddAsChild:
      "This user cannot be added as a student under your care due to an incompatible role.",
    packageNotFound:
      "The package related to this course is currently unavailable. Please contact support for further information.",
    packageOptionNotFound:
      "{package} not found. Please contact support for further information.",
    selectPackage: "Please select a package before moving to the next step.",
    requiredField:
      "Please fill in all required fields before moving to the next step. ",
    loginField: "Please enter your username and password to log in.",
    wrongUserPassword:
      "Incorrect username or password. Please check your information and try again",
    loginBeforeCart: "Please log in before adding the course to the cart",
    loginBeforeOrder: "Please log in before purchasing the course",
    plsTryAgain: "An error occurred, please try again.",
    saveFailed: "Unable to save the data. Please check and try again.",
    wrongRoleAddChild:
      "Only users with the role of 'General User' or 'Student' can be added as your child.",
    cantGetUserProfile: "Failed to load user profile. Please log in again.",
    deleteFileError: "Something went wrong. Unable to delete the file.",
    coachNotAllowCheckin: "Check-in is not within the allowed time",
    uploadMaxFileSzie: "This file cannot be uploaded because it exceeds {count} MB"

  },

  forms: {
    personalInfo: "Personal Information",
    usernameOrEmail: "Username (ONE ID) / Email",
    addParentInfo: "Add Parents Information",
    registerFor: "Register ",
    registerReserve: "Register (จอง)",
    selfRegister: "Myself",
    otherRegister: "Others",
    fillParentInfo: "Fill in Parent Information",
    learnerNumber: "Learner No.",
    username: "Username ",
    password: "Password",
    confirmPassword: "Confirm Password",
    firstname: "First Name",
    lastname: "Last Name",
    nickname: "Nickname",
    phone: "Phone Number",
    email: "Email",
    school: "School",
    gradeLevel: "Grade Level",
    allergy: "Medical Conditions/Food Allergies (optional)",
    changeProfile: "Change Profile Picture",
    edit: "Edit Profile",
    usernameOrEmailHint: "Enter your username (ONE ID) /email",
    usernameHint: "Enter your username",
    passwordHint: "Enter your password",
    confirmPassHint: "Confirm your Password",
    emailHint: "Enter your email",
    firstNameHint: "Enter your first name",
    parentFirstnameHint: "Enter your parent's  first name",
    parentLastnameHint: "Enter your parent's last name",
    lastNameHint: "Enter your last name",
    nickNameHint: "Enter your nickname",
    phoneHint: "Enter your phone number",
    parentPhoneHint: "Enter your parent's  phone number",
    schoolHint: "Enter your school name",
    gradeLevelHint: "Select your grade level",
    allergyHint: "List medical conditions/food allergies (optional)",
    addMore: "Add More Learners",
    noAccount: "Don’t have an account?",
    createOneID: "Create a OneID account.",

    // --- Register Page ---
    firstNameTH: "First name (In Thai)",
    lastNameTH: "Last name (In Thai)",
    firstNameEN: "First name (In English)",
    lastNameEN: "Last name (In English)",
    firstNameHintTH: "Enter your first name in thai",
    lastNameHintTH: "Enter your last name in thai",
    firstNameHintEN: "Enter your first name in english",
    lastNameHintEN: "Enter your last name in english",
    nickNameTH: "Nickname (In Thai)",
    nickNameEN: "Nickname (In English)",
    agree: " I understand and agree to the",
    termofService: "Terms of Service & Privacy Policy",
    forget: "Forgot your password ?",

    // Select time & coach Page
    selectClassTime: "Select Time",
    selectTime: "Select Class Time",
    selectDay: "Select Class Days",
    selectCoach: "Select Your Coach",
    classDay: "Class Day",
    classTime: "Class Time",
    classCoach: "Class Coach",
    step: "STEP",
    optional: "optional",
    none: "None",
    select: "select",
    selected: "selected!",
  },
  label: {
    manage: "Manage",
    location: "Location",
    contactUs: "Contact Us",
    filter: "Filter",
    clear: "Clear",
    save: "Save",
    order: "Order",
    download: "Download",
    name: "Full Name",
    nickname: "Nickname",
    attendanceCount: "Attendance Count",
    classAttendance: "Class Attendance",
    makeupClassDay: "Makeup Class Day",
    comment: "Comments",
    comments: "Additional Comments",
    noComment: "(No additional comments...",
    addComment: "Add a Comment",
    moreComment: "Enter Your Comment ...",
    viewComment: "View Comment",
    clearForm: "Clear",
    progressHomework: "Progress / Homework",
    uploadFiles: "Upload Attachment",
    uploadType: "Attach Image or Video",
    browseFile: "Browse File",
    specify: "Specify",
    interests: "Interests",
  },
  course: {
    noLearningJourney: "No Learning Journey",
    by: "by",
    hours: "{count} hour | {count} hours",
    price: "Price",
    package: "Package",
    frequency: "{count} Time | {count} Times",
    studentCount: "Enrollment Count",
    capacity:
      "This package can accommodate up to {count} person | This package can accommodate up to {count} people",
    certification: "Certification",
    dateAndTime: "Date and time",
    privilege: "Privilege",
    privilegeDetail:
      "Enjoy Exclusive Benefits with Monthly / Term / Yearly Enrollments.",
    course: "Course",
    time: "Time",
    searchResult: "Search Results",
    courseCategory: "Spheres",
    allCategory: "All Spheres",
    courseType: "Course Type",
    allCourse: "All Courses",
    generalCourse: "General Course",
    shortCourse: "Short Course",
    coursePeriod: "Hours / Session",
    registrationDate: "Registration Date",
    classDate: "Class Date",
    classDays: "Days of the Week",
    classTime: "Class Time",
    coach: "Coach",
    selectCoach: "Select Coach",
    alreadyBuy:
      "You’ve already purchased this course. Please check your purchase history.",
    alreadyCart:
      "This course is already in your cart. Please review  your cart.",
    successCart: "Course added to your cart successfully!",
    failCart: "Oops! Something went wrong. Please try adding the course again.",
    noCartProduct: "No courses in your cart",
    addChild: "Register for your child",
    addChildOneID: "One ID Account",
    addChildNoID: "Fill in personal information",
    hintAddChildNoID:
      "By adding a student with this method, the system will not create an account for the student. Parents will be responsible for managing the information, such as submitting absence requests and tracking class schedules.",
    reserveWarning:
      "Currently, there are {count} seats available. If you select more students than the course allows, after payment, the system will register all students with the status “Reserved Course” instead. To purchase the course, please select no more than {count} students.",
    reserve: "Reserve Course",
    noreserveFound: "No reservation history found",
    noCourseFound: "No enrollment history found",

    noSeatAvailable:
      "This course is fully booked. If you would like to <b>reserve the course</b>, please click the next button, or <a href='/course'>click here</a> to view other courses.",
  },
  hour: {
    _1hr: "0-1 hour",
    _2hr: "1-2 hours",
    _3hr: "2-4 hours",
    _4hr: "4 hours or more",
  },
  day: {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday",
  },
  shortDay: {
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },

  profile: {
    plsFillForm:
      "To purchase courses and use the system, please fill in your personal information.",
    dataPrivacyIns:
      "Your information will be kept confidential and used for service purposes only.",
    notOneId: "ONE ID not linked",
    addParent: "Add Parent",
    addStudent: "Add Student",
    viewProfile: "View Profile",
    studentProfile: "Student Information",
    certiNotFound: "No certificates and competitions found",
    plsAddFile: "Please attach the certificate/competition file.",
    plsOnlyOneFile: "Please upload no more than 1 attachment file.",
    general: "General",
    password: "Password",
    language: "Language",
    myCourse: "My Course",
    myReserve: "Booked Course",
    delCertificate: "Delete Certificate",
    editCertificate: "Edit Certificate/Competition",
    confirmCertificate: "Do you want to add this certificate?",
    confirmEditCertificate: "Confirm editing this certificate?",
    confirmDelCertificate: "Confirm deleting this certificate?",
    competitionsAndCertificates: "Competitions and Certificates",
    addCertificate: "Add Certificate or Competition",
    competitionNameHint: "Enter the competition name",
    competitionName: "Competition / Certificate Name",
    competitionDate: "Competition Date",
    competitionDateHint: "Enter the competition date",
    competition: "Competition",
    uploadCompetition: "Upload certificate file",
    parentInformation: "Parent Information",
    courses: "Courses",
    privacyPolicy: "Privacy Policy",
    termsAndConditionsofService: "Terms And Conditionsof Service",
    logout: "Logout",
    // Alert Message For Profile Page
    noParent: "No guardian found.",
    noStudent: "No student found under care.",
    successUpdateProfile: "Profile updated successfully.",
    deletedParent: "The user has been removed as a guardian.",
    addedParent: "The user has been added as a guardian.",
    deletedStudent: "The user has been removed as a student under care.",
    addedStudent: "The user has been added as a student under care.",
    doublyParent: "This user is already registered as a guardian.",
    doublyStudent: "This user is already registered as a student.",
    addYourSelf: "You cannot assign yourself as a guardian.",
  },
  Cart: {
    coach: "Coach",
    userName: "Student name",
    classDate: "Date of study",
    classTime: "Study time",
    showMore: "Show Students List",
    hide: "Hide Students List",
    warningDelete:
      "Are you sure you want to remove this course from your cart?",
    confirmDelete: "Yes, delete it!",
    noItemsSelected: "No items selected",
    paymentSuccess: "Payment successful",
    paymentFailed: "Payment failed",
    paymentError: "Payment error",
    cancelDelete: "Cancel",
    deleteSuccess: "Product has been successfully deleted.!",
    noHistory: "No Purchase History",
    startLearn: "Start learning something new today!",
    seeAllCourse: "Browse All Courses",
    seeCart: "View Cart",
  },
  historyOrder: {
    classDate: "Date of study",
    classTime: "Study time",
    coach: "Coach",
    userName: "Student name",
    allStatus: "All",
    pendingStatus: "PENDING",
    compiledStatus: "COMPLETE",
    cancelStatus: "Cancel Order",
    successCancel: "This order has been successfully cancelled!",
    confirmCancel: "Would you like to cancel this order?",
  },

  sweetAlert: {
    reserveQa: "Do you want to reserve this course?",
    error: "An error occurred",
    areYouSure: "Are you sure?",
    successEditAlert: "Your changes have been saved.",
    deleteParent: "Confirm removal of this user as your guardian",
    deleteStudent:
      "Confirm removal of this user as your student under your care",
    deleteCourse: "Do you want to delete this course?",
    deleteCategory:
      "Delete this sphere? All associated courses will also be removed.",
    confirm: "Confirm",
    cancel: "Cancel",
    cancelCourse: "Do you want to cancel purchasing this course?",
    warnCancelCourse:
      "If you cancel, the information you entered will not be saved",
    yes: "Yes, cancel now!",
    no: "No, proceed",
  },

  attendanceStatus: {
    onTime: "On Time",
    late: "Late",
    absent: "Absent",
    leave: "Leave",
    emergencyLeave: "Emergency Leave",
    attendanceStatus: "Attendance Status",
  },
  coach: {
    noReportFound: "No teaching records found for this course",
    learner: "learner",
    evaluationDetail: "Evaluation Details",
    hintInterestField: "Student's interest...",
    markAttendance: "Attendance",
    evaluation: "Evaluation",
    evaluationStd: "Evaluate Student",
    evaluationPoten: "Evaluate Potential",
    classSummary: "Summary",
    summaryAndHomework: "Summary and Homework",
    lessonRecord: "Lesson Record",
    progressLev: "Progress level",
    progress: "Progress",
    attentionLev: "Attention level",
    attention: "Attention",
    teachingRec: "Teaching Record",
    selectCourse: "Select Course",
    selectDate: "Select Date",
    selectTeachRec: "Select a course to view the teaching records",
    studentList: "Student List",
    leaveRec: "Leave Record",
    teachingInf: "Teaching Information",
    noClass: "No classes on this day",
    warnNoStudentReport: "Student evaluation data not found",
    warnNoPotentialReport: "Student's potential evaluation data not found",
    warnNoSummaryReport: "Class summary data not found",
    notAllCheckin:
      "Please select the participation status for all students before saving",
    allCheckin: "Student attendance has been recorded",
    saveEvaluation: "Evaluation has been recorded.",
    saveReport: "Teaching summary has been recorded.",
    cantEvaluateClass: "Student evaluation is not available",
    cantEvaluateClassIns: "There were no students in attendance for this class",
    cantEvaluate: "Evaluation not available now.",
    cantEvaluateIns:
      "You can evaluate once at least one student has completed this course",
    noreserveFound: "You haven't booked any courses yet",
    noCourseFound: "You haven't enrolled in any courses yet",
    errorNotAllEvaluate: "Please evaluate all students before saving",
  },
  drawerMenu: {
    overview: "Overview",
    logout: "Log out",
    classSchedule: "Schedule",
    parentInfo: "Parent Information",
    studentInfo: "Student In Care",
    coachMenu: "Coach Management",
    adminMenu: "Admin View",
    userMenu: "User View",
    course: "Course",
    myCourse: "My Course",
    contestCertificate: "Competitions & Certificates",
    portfolio: "Portfolio",
    password: "Password",
    language: "Language",
    myAccount: "My Account",
    myPurchase: "My Purchase",
    policy: "Policy",
    term: "Terms of Service & policy",
    privacyPolicy: "Privacy Policy",
    setting: "Setting",
    notification: "Notification",
  },
  pluralize: {
    person: "{count} person | {count} people",
    student:"{count} student | {count} students",
    course: "{count} course | {count} courses",
    bahtPerson: "฿{count} /person",
  },
  forgotPassword: {
    forgotPassword: "forgot password ?",
    changePassword: "Change Password ?",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    bySMS: "Identity verification via SMS",
    byEmail: "Identity verification via Email",
    changeByEmail: "Change password via email.",
    changeBySMS: "Change password via phone number (SMS).",
    changeViaEmail:
      "A verification code has been sent to your email. Please enter the code to proceed.",
    otpViaSMS:
      "An OTP has been sent to your phone number via SMS. Please enter the code to proceed.",
    checkSMS: "Check your SMS",
    checkEmail: "Check your email",
    dontReciveOTP: "Didn't receive the code?",
    resetPassword: "Reset Password",
    resend: "Resend",
    passwordRules: "Your password must be contain",
    backToHome: "Return to Homepage",
    backToLogin: "Return to Login",

    //Error & Alert
    wrongUserPhone:
      "The username or phone number is incorrect. Please check and try again.",
    wrongPhoneNumber:
      "The phone number entered is incorrect. Please check and try again.",
    wrongUserEmail:
      "The username or email is incorrect. Please check and try again.",
    wrongEmail:
      "The email entered is incorrect. Please check the email and try again.",
    wrongOTP: "The OTP entered is incorrect. Please check and try again.",
    successChangePass: "Your password has been successfully changed.",
    sucessSentEmail:
      "A link to reset your password has been sent to your email.",
    otpFail: "Sorry, there was an error sending the OTP. Please try again.",
  },
  learnerClass: {
    period: "Period",
    coach: "Coach",
    development: "Development",
    Interest: "Interest",
    showMore: "View More",
    showLess: "View Less",
    comments: "Comments",
    studytime: "Study time",
    studyinformation: "Study Information",
    selectAll: "Select All",
    cancel: "Cancel",
    downlode: "Download",
    confirmDownload: "Do you want to download the evaluation results?",
    confirm: "Confirm",
    evaluationResults: "Evaluation Results",
    AssignedWork: "Assigned Work",
    Reserved: "Reserved",
    time: "time",
    downloadFile: "Download file",
    noClassCheckIn:
      "The student has not attended any class sessions in this course.",
    selectChild: "Please select a student to view the schedule",
    selectChildCourse: "Please select a student to view their courses",

  },

  learnnerSchedules: {
    Day: "Day",
    Week: "Week",
    Month: "Month",
    Time: "Time",
    Schedules: "Schedules",
    detail: "Detail",
    notstudy: "No study history",
    seeDetail: "See detail",
  },
  coursesBooked: {
    classDate: "Date of study",
    classTime: "Study time",
    coach: "Coach",
    userName: " Student name",
    allStatus: " All",
    pendingStatus: " PENDING",
    compiledStatus: " COMPLETE",
    cancelStatus: " CANCEL",
    courseHourPerTime: " Hours/Session",
  },
  status: {
    ALL: "All",
    PENDING: "PENDING",
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    CANCEL: "CANCEL",
    CONFIRM: "CONFIRM",
  },
  coachLeave: {
    selectTeachingInformation: "Select Teaching Information",
    courseName: "Course Name",
    editSubClss: " Edit Make-up Class Details",
    leaveForm: "Leave Request Form",
    confirmLeave: " Confirm Leave ?",
    successLeave: "Leave Request Successful",
    successCancelLeave: "Cancel Leave Request Successful",
    cancelLeave: "Cancel Leave",
    list: "List",
    index: "No.",
    leaveDate: "Leave Date",
    startDate: "Start Date",
    endDate: "End Date",
    leaveTypeCode: "Leave Type",
    remarkLeave: "Remark Leave",
    leaveDetail: "Leave Form Details",
    status: "Status",
    detail: "Detail",
    period: "Period",
    fullTime: "All Day",
    startTime: "Start Time",
    endTime: "End Time",
    makeUpTime: "Make-up Time",
    remarkReject: "Reject Reason",
    uploadAttachments: "Upload Attachments",
    attachments: "Attachments",
    SICK: "SICK",
    BUSSINESS: "BUSINESS",
    ANNUAL: "ANNUAL",
    MULTERNITY: "MULTERNITY",
    teachingDate: "Teaching Date",
    newTeachingDate: "Make-up Teaching Date",
    newTeachingTime: "Teaching Time",
    subTeacher: "Substitute Teacher",
    course: "Course",
    warningRemark: "Please enter the reason for leave.",
  },
  adminDrawer: {
    dashboard: "Dashboard",
    userManage: "User Management",
    courseManage: "Course Management",
    manageSchedule: "Manage Teaching Schedule",
    manageAllCourses: "Manage Course",
    createCourse: "Create Course",
    manageBookings: "Manage Reservation",
    regions: "Regions",
    manageCategory: "Sphere Management",
    createCategory: "Create Sphere",
    finance: "Finance",
    leaveApproval: "Leave Approval",
    manageCheckIns: "Manage Check-ins",
    checkInByOrder: "Check-ins by Order",
    checkInByCourse: "Check-ins by Course",
    manageEvents: "Manage Events",
    editUser: "Manage User",
    importUsers: "Import Users",
    addStudent: "Add Learner",
    survey: "Satisfaction Survey",
    events: "Events setting",
    attendance: "Manage Check-in Later",
  },

  createCourse: {
    deletePackagePlan: "Do you want to delete this package plan?",
    uploadCourseImg: "Upload Course Cover Image",
    uploadImgIns:
      "Please upload an image with a size of 1024 x 576 px (16:9), file size not exceeding 5 MB, and in JPG or PNG format only.",
    courseNameTH: "Course Title (in Thai)",
    courseNameEN: "Course Title (in English)",
    courseLocation: "Course Location",
    studentCapacity: "Enrollment Capacity",
    coursePrice: "Course Fee/Person",
    classPeriod: "Hours/Session",
    courseReserve: "Course Booking",
    reserveDateRange: "Reservation Period",
    selectCategory: "Specify Sphere",
    baht: "Baht",
    discount: "Discount/Person",
    dateAndTime: "Date and Time",
    registDateRange: "Registration Period",
    studyDateRange: "Study Day",
    courseOpenDate: "Course Open Date",
    teachDateRange: "Teaching Day",
    selectStartDate: "Select Start Date",
    selectEndDate: "Select End Date",
    selectDay: "Select Study Day",
    uploadJourney: "Upload Image and Video for Learning Journey",
    uploadJourneyIns:
      "Please upload images or videos up to 10 MB in size. For videos, only MP4 format is supported.",
    addLink: "Add Link",
    addMore: "Add More",
    reserveBefore: "Reservation Period",
    otherDetail: "Additional Information",
    preRegister: "Open Pre-Registration Before Course Start",
    addPackage: "Add Package",
    addPackagePlan: "Add Package Plan",
    packagePlanNo: "Package Plan No.",
    sessionReq: "Required Sessions",
    packageLimit: "Student Capacity (person)",
    packagePlan: "Package Plan ",
    selectPlan: "Select Package Plan",
    packageType: "Package Type",
    packageNo: "Package No",
    uploadPrivilageIns:
      "Upload an image with a size of 1024 x 576 (16:9) and a file size no larger than 1 MB, in JPG or PNG format.",
    uploadPrivilage: "Upload Privileges",
    coachOepn: "Ready to Teach",
    coachCapacity: "Student Capacity",
    timeAndCoach: "Duration/Coach",
    packAndPrivilage: "Package/Privilage",
    addMoreCoach: "add More Coach",
    createCourse: "Create Course",
    uploadURL: "Import Video URL",
    selectDayIns: "Select Days (Monday - Sunday)",

    successEdit: "Edit Course Successfully!",
    successAdd: "added Course Successfully!",
    successDelete: "deleted Course Successfully!",
    failUpdateStatus: "Unable to change the status of this course",
    deleteCategoryImg: "Do you want to delete the cover image of this sphere?",
    deleteCourseImg: "Do you want to delete this image ?",
    deleteThisFile: "Are you sure you want to delete this file?",
  },
  courseCoach: {
    coachName: "Coach Name",
    teachingTime: "Teaching Time",
    dateAndTeachTime: "Date and Teaching Time",
    addTeachingTime: "Add Teaching Time",
    delTeachingTime: "Delete Teaching Time",
    addteachingDay: "Add Teaching Day",
    deleteCourseCoach: "Confirm removing this coach from the course?",
    confirmEditCoach: "Confirm coach information changes",
    conEditCoachAlreadyTeach:
      "These changes may affect class schedules. Please confirm before proceeding.",
    atLeastOneCoach:
      "Cannot remove coach. There must be at least 1 coach remaining.",
    alreadyTeach:
      "Cannot remove because there are students currently learning with this coach",
    successEdit: "Coach information has been successfully updated",
    successAdd: "Coach added successfully!",
    successDelete: "Coach removed successfully!",
  },
  category: {
    manageCategory: "Mange Sphere",
    categoryImg: "Sphere Image",
    uploadCategoryImg: "Upload Sphere Image",
    categoryTH: "Sphere Name (in Thai)",
    categoryEN: "Sphere Name (in English)",
    taughtBy: "Instructor",
    categoryDetail: "Sphere Details",
    description: "Description",
    addCategory: "Add Sphere",
    successEdit: "Edited Sphere Successfully!",
    successDelete: "Delete Sphere Successfully!",
    successAdd: "Added Sphere Successfully!",
  },
  courseStatus: {
    open: "Open",
    close: "Close",
    tempClose: "Temporarily Close",
    openReserve: "Open for Reservation",
    draft: "Draft",

    // StudentList Reserve Status
    pending: "Pending",
    cancel: "Cancelled",
    complete: "Completed",
  },
  studentList: {
    goToMyCoursePage: "View My Courses",
    goToStudentCoursePage: "View Student's Courses",
    attendanceStatus: "สถานะการเข้าชั้นเรียน",
    classEvaluation: "Student Performance Evaluation",
    courseEvaluation: "Student Potential Assessment",
    studentList: "Student List",
    checkIn: "Check-in",
    coachList: "Coach List",
    fullname: "Name",
    ongoing: "Currently Enrolled",
    completed: "Course Completed",
    reserve: "Course Reserved",
    export: "Export Data",
    noStudent: "No student records found",
    reserveDate: "Reservation Date",
    viewEvaluation: "view evaluation",
    viewProfile: "view profile",
    searchStudent: "Type to search students...",
    studentListView: "Student List View",
    classView: "Class View",
  },
  notification: {
    noMessage: "No notification messages found",
    errorTitle: "An error occurred!",
    noSeatAvailable:
      "Unfortunately, there are no more available seats in the course.",
  },
  userRole: {
    ADMIN: "admin",
    PARENT: "parent",
    STUDENT: "student",
    GUEST: "general user",
  },
  user: {
    selectRole: "Select Role..",
    selectAll: "Select All",
    allUser: "All Users",
    role: "Role",
    user: "User",
    admin: "Admin",
    parent: "Parent",
    coach: "Coach",
    student: "Student",
    addUser: "Add User",
    contactedAll: "Contacted all",
    edit: "Edit User",
    userRole: "User Role",
    deleteUser: "User will be permanently deleted and cannot be restored.",
    successDelete: "The user has been successfully removed.",
    failedDelete: "Failed to delete user. Please try again.",
  },
  enroll: {
    confirmAddStudent:"Confirm adding student?",
    plsSelectStudent:"Please select at least one student",
    plsSelectCourse:"Please select at least one course",
    remark:"Remark",
    addLearner: "Add Learner",
    chooseLearner: "Select Learner",
    chooseLearnerIns: "Search and select learner",
    chooseCourse: "Select Course",
    chooseCourseIns: "Select the course to register for",
    payment: "Payment Details",
    paymentIns: "Enter details or send payment reminder",
    alreadyPurchase: "Already Paid",
    sendPaymentReminder: "Send Payment Reminder",
    searchCourse: "Search Courses...",
    addOnDiscount: "Add-on Discount/Person",
    selectCoachAndTime: "Select Coach and Study Time",
    startClassDate: "Class Start Date",
    successEnroll: "Learner added successfully",
    failEnroll:
      "Unable to add learner. Please check the information and try again.",
    successAdd: "This user has been successfully added to the system!",
  },
  payment: {
    paymentSuccess: "payment completed",
    paymentFailed: "payment failed",
    paymentPending: "payment pending",
    paymentCancelled: "payment cancelled",
    orderID: "Order ID",
    paymentDate: "Transaction Date",
    paymentTime: "Transaction Time",
    paymentBy: "Paid by",
    paymentAmount: "Payment Amount",
    // Payment Method
    bank: "Bank Transfer",
    schoolBank: "Transfer to School",
    qrPayment: "QR Payment",
    cash: "Cash",
    creditCard: "Credit Card",
    method: "Payment Method",
    receivedBy: "Received By",
    transactionDate: "Transaction Date",
    cancelDate: "Cancellation Date ",
    searchHint: "Search by student / course name / order number",
    export: "Export",
  },
  finance: {
    discount:"Discount",
    addOnDiscount:"Add-on Discount",
    confirmPayment: "Confirm payment",
    confirmSendNoti: "Confirm sending the payment reminder?",
    successNoti: "Payment reminder sent successfully!",
    errorNoti: "An error occurred. Failed to send payment reminder.",
    autoCancelIns:
      "This order will auto-cancel if unpaid within 3 days after placing the order.",
    qaConfirmPayment: "Are you sure you want to confirm the payment?",
    successConfirm: "Payment confirmed successfully",
    errorConfirm: " Failed to confirm payment",
    conflictCourse: "Courses scheduled during holidays",
    finance: "Finance",
    courseList: "Course List",
    selectPaymentType: "Select payment method",
    createOrderStep: "Create Order",
    paymentHistory: "Payment History",
    paymentStatus: "Payment Status",
    paymentDate: "Payment Date",
    canceltDate: "Cancelled Date",
    paymentMethod: "Payment Method",
    paymentAmount: "Payment Amount",
    paymentDetails: "Payment Details",
    transactionID: "Transaction ID",
    transactionDate: "Transaction Date",
    cancelDate: "Cancellation Date",
    searchHint: "Search by student / course / order no.",
    export: "Export",
    genReciept: "Generate Receipt",
    totalItem: "Item Summary",
    createdBy: "Created By",
    customerName: "Processed By",
    fianceDetail: "Peyment detail",
    purchaseValue: "Purchase Value",
    reportFail:
      "The requested financial report could not be found. Please verify the information and try again.",
    selectReportLang: "Export language",
    orderDetail: "Order details",
  },
  paymentStatus: {
    total: "Total",
    success: "Completed",
    pending: "Pending",
    cancel: "Cancelled",
    failed: "Failed",
  },
  schedule: {
    delHolidayConflict:
      "Unable to delete the holiday because there is a make-up class rescheduled from that holiday that has already been checked in.",
    exportIns:
      "This export includes coach check-in records and students’ class attendance.",
    manageByCourse: "Manage by Course",
    manageByClass: "Manage by Session",
    searchTimeTable: "Search by course name or coach name...",
    viewStudentList: "View StudentList",
    editSchedule: "Edit Class Schedule",
    TeachSchedule: "Teaching Schedule",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    manage: "Manage Teaching Schedule",
    seatStatus: "Course Status",
    selectCourseStatus: "Select Course Status",
    full: "Full",
    available: "Available",
    coachCheckIn: "coach check-in",
    studentCheckIn: "student check-in",
    alreadyCheckIn: "checked in",
    notCheckIn: "not checked in",
    noRecord: "Attendance status not recorded",
    holiday: "Holiday",
    manageHoliday: "Manage Holidays",
    addHoliday: "Add Holiday",
    editHoliday: "Edit Holiday",
    deleteHoliday: "Delete Holiday",
    confirmCreateHoliday: "Do you want to add this holiday?",
    confirmDeleteHoliday: "Are you sure you want to delete this holiday?",
    successAddHoliday: "Holiday added successfully!",
    successDeleteHoliday: "Holiday deleted successfully!",
    successEditHoliday: "Holiday edited successfully!",
    holidayName: "Holiday Name",
    holidayDate: "Holiday Date",
    holidayDescription: "Holiday Description",
    searchSchedule: "Search Schedule...",
    checkInDetail: "Check-in Details",
    editHolidayIns:
      "Only the name can be edited. To change the date, delete and re-add the holiday.",
  },
  leaveManagement: {
    reason: "Leave Reason",
    leaveManagement: "Leave Management",
    leaveRequest: "Leave Request",
    leaveType: "Leave Type",
    leaveDate: "Leave Date",
    reqDate: "Request Date",
    leaveStatus: "Leave Status",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancel Request",
    subClassDate: "Make-up Class Date",
    duplicateReq:
      "You’ve already submitted a leave for this period. Duplicate requests aren’t allowed.",
    successApprove: "Leave request approved successfully!",
    successReject: "Leave request rejected successfully!",
    confirmApprove: "Are you sure you want to approve this leave request?",
    confirmReject: "Are you sure you want to reject this leave request?",
    today: "Today's schedule",
    leave: "Leave Management",
    searchHint: "Search by coach name ... ",
    conflictCourse: "Courses Scheduled During Leave",
    applicant: "Applicant",
    addLeave: "Add Leave Record",
    leaveAllDay: "Full Day",
    leaveAM: "Half Day (Morning)",
    leavePM: "Half Day (Afternoon)",
    leaveTime: "Leave Type",
    leaveForm: "Leave Submission Form",
    personalLeave: "Personal Leave",
    sickLeave: "Sick Leave",
    vacationLeave: "Vacation Leave",
    leaveReason: "Reason for Leave",
    rejectReason: "Rejection Reason",
    noSubstitute: "No Substitute",
    substituteAssign: "Substitute Assigned",
    subClassCoach: "Substitute Coach",
    SubClassDate: "Rescheduled Class Date",
    confirmLeave: "Are you sure you want to submit this leave request?",
    confirmCancel: "Are you sure you want to cancel this leave request?",
    successCancelLeave: "Leave request cancelled successfully!",
    originalClassDate: "Original Class Date",
    failCreateLeave:
      "เAn error occurred while creating the leave request. Please try again.",
    successCreateLeave: "Leave request submitted successfully.",
    uploadMaxFileSize: "Cannot upload this file because it exceeds {count} MB.",
  },
  dashboard: {
    langSelect: "Select Export Language",
    noIncomeReport: "There is no course income for the selected period",
    selectAllIns:
      "If you want to export reports for all courses in the system, please leave all checkboxes unchecked.",
    fullCourse: "Full Courses",
    availableCourse: "Empty Courses",
    unitCoach: "coaches",
    enrollCount: "Enrolled Courses",
    courseList: "List of Courses",
    allYear: "All Year",
    income: "Income",
    incomeIns: "Income Summary",
    IncomeProportion: "Income Proportion",
    IncomeProportionIns: "Income Summary by Course",
    full: "Full",
    available: "Available",
    active: "Active",
    onLeave: "On Leave",
    allStudents: "Total Students",
    onGoing: "Currently Enrolled",
    almostDone: "Nearly Completed",
    reserved: "Course Reserved",
    courseStatistic: "Popular Course Statistics",
    topCourse: "Top 10 Courses with the Most Students",
    courseStatusIns: "List of Courses with Available and Full Seats",
  },
  events: {
    addPicture: "Add a Picture",
    exampleOfPictures: "example of pictures",
    noImage: "There Are No Preview Images",
    advice: "Advice",
    suggesImage: "Images Should Be Uploaded With A Size Of 1024 x 576 (16:9)",
    save: "Save",
    toManyImage: "can't upload images more than 10",
    question: "Do You Want To Upload Events",
    yes: "Yes",
    no: "No",
    success: "Upload Events Successfuly",
    error: "Please Upload No More Than 10 Events",
    questionDelete: "Do You Want To Delete This Event",
    errorDelete: "This Events Can't Be Delete",
    successDelete: "Delete Event Successfuly",
  },

  consent: {
    agree: "Agree",
    dontAgree: "Disagree",
    consent: "Consent",
    pdpaTitle: "PDPA Consent",
  },

  attendance: {
    evaluated:"Student Evaluated",
    completed:"Course Completed",
    allStudent: "All Students",
    attendanceIns:"Manage Student Attendance",
    total: "Total",
    checked: "Checked",
    unChecked: "UnChecked",
    index: "Index",
    courseName: "Course Name",
    coachName: "Coach Name",
    date: "Date",
    time: "Time",
    status: "Status",
    detail: "Detail",
    checkInToTeach: "CheckIn To Teach",
    unCheckInToTeach: "UncheckIn To Teach",
    checkInStudent: "Check Student Attendance",
    present: "Present",
    late: "Late",
    absent: "Absent",
    leave: "Leave",
    emergencyLeave: "Emergency Leave",
    postponed: "Reschedule",
    unchecked: "Unchecked",
    SetPostponed: "Set The Date And Time For Postpon class",
    studentName: "Student Name",
    compensatoryStudyDay: "Compensatory Study Day",
    compensatoryStudyTime: "Compensatory Study Time",
    saveAttendance: "Save Attendance",
    cancel: "Cancel",
    savePostponed: "Confirm Postponed",
    question: "Do You Want To Save Attendance",
    yes: "Yes",
    no: "No",
    saveSuccess: "Save Attendance Completed",
    errorSave: "Save Attendance Failed",
  },
  reserve: {
    contactedDate: "Booking Approved Date",
    cancelledDate: "Booking Cancelled Date",
    allContactQa:
      "Do you want to change all 'Waiting to Contact' bookings to 'Contacted'?",
    searchHint: "Search by course / student name...",
    reservedCourse: "Reserved Course",
    reserveDate: "Reservation Date",
    studentName: "Student Name",
    reserverName: "Reserver Name",
    phone: "Phone Number",
    newest:"Newest",
    oldest:"Oldest",
    reserveDetail:"Reservation Details",
    reserverInfo:"Reservation Info",
    changReserveStatus: "Change Reservation Status",
    confirmChangeStatus: "Do you want to change the reservation status to \"{status}\"?",
    reserveDateRange:"Reserve Date Range",
  },
};
